import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

export const TypingChart = ({ history, small }) => {
  const data = [...(history || [])].reverse().map((h, i) => ({ n: i + 1, wpm: h.net_wpm, acc: h.accuracy, at: new Date(h.at).toLocaleDateString() }));
  if (data.length < 2) return small ? null : <p className="text-sm text-slate-500" data-testid="typing-chart-empty">Take the test at least twice to see your progress chart.</p>;
  return (
    <div className={small ? "h-16 mt-2" : "h-56"} data-testid={small ? "typing-sparkline" : "typing-chart"}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 6, right: 8, left: small ? 8 : -18, bottom: 0 }}>
          {!small && <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />}
          {!small && <XAxis dataKey="n" tick={{ fontSize: 11 }} />}
          {!small && <YAxis tick={{ fontSize: 11 }} />}
          {!small && <Tooltip formatter={(v, k) => [k === "wpm" ? `${v} WPM` : `${v}%`, k === "wpm" ? "Speed" : "Accuracy"]} labelFormatter={(n) => `Test ${n} · ${data[n - 1]?.at}`} />}
          <Line type="monotone" dataKey="wpm" stroke="#f59e0b" strokeWidth={3} dot={!small} />
          {!small && <Line type="monotone" dataKey="acc" stroke="#0f172a" strokeWidth={1.5} strokeDasharray="4 3" dot={false} />}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
